import React, { useEffect, useRef, useState } from "react";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import useDeviceType from "../../../custom-hooks/DeviceType";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../../component-lib/Molecules/button/Button";
import EventEHRTabs from "../../../component-lib/Molecules/tabs/EventEHRTabs";
import Table from "../../../component-lib/Organisms/table/EventEHRTable";
import EventEHRHeading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import EventEHRContactInformationCard from "../../../component-lib/Molecules/contact-information-card/EventEHRContactInformationCard";
import EventEHRCreateVisitDialog from "../../../component-lib/Organisms/create-visit-dialog/EventEHRCreateVisitDialog";
import EventEHREditProfileDialog from "../../../component-lib/Organisms/edit-profile-dialog/EventEHREditProfileDialog";
import MenuDropdown from "../../../component-lib/Molecules/menuDropdown/MenuDropdown";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PatientListService from "../../../services/PatientListService";
import EventEHREditEmergencyContactDialog from "../../../component-lib/Organisms/edit-emergency-contact-dialog/EventEHREditEmergencyContactDialog";
import EventEHREditUnitLeaderDialog from "../../../component-lib/Organisms/edit-unit-leader-dialog/EventEHREditUnitLeaderDialog";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import EventEHRPatientProfileDetailCardWithEdit from "../../../component-lib/Organisms/patient-profile-detail-card/EventEHRPatientProfileDetailCardWithEdit";
import useHasOverflow from "../../../custom-hooks/HasOverflow";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewVisit,
  createTriage,
  getPatientDetailsDataByTabWise,
  getPatientProfileData,
  getVisitNoteById,
  patchEmergencyContactData,
  patchBaseCampData,
  patchVerifyOrder,
  getPatientDocuments,
  uploadPatientDocument,
  deletePatientDocument,
  patchPatient,
  deleteVisit,
} from "../patientSaga";
import {
  componentKey,
  getViewPatientProfileData,
  setCloseCreatePatientDrawer,
  setCloseCreateTriageDrawer,
  setCloseCreateVisitDrawer,
  setCloseEmergencyContactDialog,
  setCloseBaseCampDialog,
  setCloseVerifyOrderStatus,
  setCreateVisitDataForTriage,
  setDataToDischargeForm,
  setNotesData,
  setOpenCreateVisitForceFullyDialog,
  setOrderChange,
  setUpdateVisitNoteDataOnceDraftNote,
  setVisitNoteCareFlowData,
  setVisitPreviewDialog,
  setCloseUploadDocumentDialog,
  setRefreshPatientList,
} from "../patientSlice";
import UploadDocumentDialog from "./dialog/UploadDocumentDialog";
import ViewDocumentDialog from "./dialog/ViewDocumentDialog";
import Input from "../../../component-lib/Atoms/Input/Input";
import { formatPhoneNumber } from "../../../utils/phoneNumberFormatter";
import { isOffsiteTypeOfCare } from "../../../utils/offsite/isOffsite";
import { isNurseTypeOfCare } from "../../../utils/careType/isNurseTypeOfCare";
import moment from "moment";
import SaveTriageDialog from "../visit-flow/SaveTriageDialog";
import {
  destructStatusData,
  getSignBackground,
  getSignDotColor,
  getSignTextColor,
  getStatusBackground,
  getStatusDotColor,
  getStatusTextColor,
} from "../../../utils/statusConstants";
import EventEHRConfirmationDialog from "../../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";
import DischargeFormPreviewModel from "../../../utils/discharge-form-preview-model/DischargeFormPreviewModel";
import TooltipForTable from "../../../component-lib/Molecules/tooltip/TooltipForTable";
import ViewOrderDialog from "../create-patient-drawer/ViewOrderDialog";
import VerifyOrderStatusDialog from "./dialog/VerifyOrderStatusDialog";
import ViewNotesModal from "./dialog/ViewNotesModal";
import RoomAssignmentDialog from "./dialog/RoomAssignmentDialog";
import { getRoomDisplayName } from "../../../utils/room/roomDisplay";
import {
  getLoginUserData,
  getUserPermission,
  getFacilityId,
} from "../../../utils/getToken";
import { getHealthHistory } from "../../../utils/healthHistoryApiLink";

const PatientDetailsScreen = () => {
  const {
    viewPatientProfileData,
    refreshPatientList,
    closeEditProfileDialog,
    closeCreatePatientDrawer,
    closeCreateVisitDrawer,
    createVisitDataFormTriage,
    closeTriageDrawer,
    tableDataForVisitTab,
    dataForEmergencyContact,
    closeEmergencyContactDialog,
    closeBaseCampDialog,
    openCreateVisitForceFullyDialog,
    openVisitPreviewDialog,
    visitNoteCareFlowData,
    updateVisitNoteDataOnceDraftNote,
    tableDataForOrderTab,
    closeVerifyOrderStatus,
    notesData,
    tableDataForDocumentsTab,
    closeUploadDocumentDialog,
  } = useSelector((state: any) => state[componentKey]);

  const userPermissionData: any = getUserPermission();

  const patientProfileData = viewPatientProfileData?.participant;
  const defaultSelectedDataOFCreateVisit = {
    patientId: viewPatientProfileData?.id,
    bsaId: viewPatientProfileData?.participant?.bsaId,
    firstName: viewPatientProfileData?.participant?.firstName,
    lastName: viewPatientProfileData?.participant?.lastName,
    clinicLocation: viewPatientProfileData?.participant?.baseCamp?.id,
    unitNumber: viewPatientProfileData?.participant?.baseCamp?.unitNumber,
    campName: viewPatientProfileData?.participant?.baseCamp?.name,
  };
  const parseLoginUserdata: any = getLoginUserData();
  const loginUserdata = JSON.parse(parseLoginUserdata);
  const facilityId = getFacilityId();
  const loginUserFacilityId =
    loginUserdata?.customAttributes?.facilityId ||
    facilityId ||
    viewPatientProfileData?.facilityId;

  // A visit can be deleted only by SuperAdmin/Admin users who also have
  // provider-portal access (isAdminAccess). Everyone else sees it disabled.
  const canDeleteVisit =
    (loginUserdata?.roleNames?.includes("SuperAdmin") ||
      loginUserdata?.roleNames?.includes("Admin")) &&
    loginUserdata?.customAttributes?.isAdminAccess === "true";

  // SuperAdmin/Admin (with provider access) are not facility-specific, so they
  // may view/open any patient's visit note regardless of the selected facility.
  // Keyed off role — their own facilityId is blank — mirroring canDeleteVisit.
  const isFacilityAgnosticAdmin = canDeleteVisit;

  const dispatch = useDispatch();
  const { patientId } = useParams();
  const [searchParams] = useSearchParams();
  const defaultSelectedTab = searchParams.get("tab"); // Replace 'yourParam' with your parameter name

  const divRef = useRef<HTMLDivElement>(null);
  const hasOverflow = useHasOverflow(divRef);
  const navigate = useNavigate();
  const deviceType = useDeviceType();

  const [openCreateVisitDialog, setOpenCreateVisitDialog] = useState(false);
  const [openEditProfileDialog, setOpenEditProfileDialog] = useState(false);
  const [openEmergencyContactDialog, setOpenEmergencyContactDialog] =
    useState(false);
  const [openUnitLeaderDialog, setOpenUnitLeaderDialog] = useState(false);
  const [openTriage, setOpenTriage] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [rowPerPage, setRowPerPage] = useState("10");
  const [selectedTab, setSelectedTab] = useState(
    defaultSelectedTab ? defaultSelectedTab : "visits",
  );
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [saveCreateVisitDataTemporary, setSaveCreateVisitDataTemporary] =
    useState<any>({});
  const [openPreviewForm, setOpenPreviewForm] = useState(false);
  const [isSignedVisit, setIsSignedVisit] = useState(false);
  const [visitId, setVisitId] = useState("");
  const [openViewOrderDialog, setOpenViewOrderDialog] = useState({
    open: false,
    defaultData: {},
  });

  const [defaultDataRowForOrder, setDefaultDataRowForOrder] = useState<any>({});
  const [openVerifyOrderDialog, setOpenVerifyOrderDialog] = useState(false);
  const [openViewNotesModal, setOpenViewNotesModal] = useState(false);
  const [selectedOrderForNotes, setSelectedOrderForNotes] = useState<any>({});
  const [openUploadDocumentDialog, setOpenUploadDocumentDialog] =
    useState(false);
  const [documentSearchKey, setDocumentSearchKey] = useState("");
  const [debouncedDocumentSearch, setDebouncedDocumentSearch] = useState("");
  const [documentPageNumber, setDocumentPageNumber] = useState(1);
  const [documentRowPerPage, setDocumentRowPerPage] = useState("10");
  const [openDeleteDocConfirmDialog, setOpenDeleteDocConfirmDialog] =
    useState(false);
  const [documentToDelete, setDocumentToDelete] = useState<any>(null);
  const [openViewDocumentDialog, setOpenViewDocumentDialog] = useState(false);
  const [documentToView, setDocumentToView] = useState<any>(null);
  const [openDeleteVisitConfirmDialog, setOpenDeleteVisitConfirmDialog] =
    useState(false);
  const [visitToDelete, setVisitToDelete] = useState<any>(null);
  const [openRoomAssignmentDialog, setOpenRoomAssignmentDialog] =
    useState(false);
  const [roomAssignmentVisitId, setRoomAssignmentVisitId] = useState("");
  const emergencyContact =
    dataForEmergencyContact?.participant?.emergencyContact?.[0];
  const unitContact = dataForEmergencyContact?.participant?.baseCamp;

  // PATIENT  DATA
  const patientDetails = [
    {
      label: "Full Name",
      value: `${patientProfileData?.firstName || "-"} ${patientProfileData?.lastName || ""}`,
    },
    {
      label: "Email",
      value: patientProfileData?.email || "-",
    },
    {
      label: "Contact Number",
      value: formatPhoneNumber(patientProfileData?.contactNumber) || "-",
    },
    {
      label: "BSA ID",
      value: patientProfileData?.bsaId || "-",
    },
    {
      label: "Date of Birth",
      value: patientProfileData?.dateOfBirth
        ? // DOB is date-only (midnight UTC) — render in UTC so it never shifts.
          moment.utc(patientProfileData?.dateOfBirth)?.format("MM/DD/YYYY")
        : "-",
    },
    {
      label: "Facility Name",
      // facility lives on the patient record (not under `participant`)
      value: viewPatientProfileData?.facility?.name || "-",
    },
    {
      label: "Assigned Provider",
      // assignedProviderName lives on the patient record (not under `participant`)
      value: viewPatientProfileData?.assignedProviderName || "-",
    },
    {
      label: "Room",
      value: getRoomDisplayName(viewPatientProfileData?.room?.room) || "-",
    },
    {
      label: "Jamboree Unit Number",
      value: patientProfileData?.baseCamp?.unitNumber || "-",
    },
    {
      label: "Jamboree Unit Leader Name",
      value: patientProfileData?.baseCamp?.leaderName || "-",
    },
  ];

  // VISIT TAB COLUMN DATA
  const patientVisitTabColumns = [
    {
      field: "Visit Date",
      label: <div>Visit Date</div>,
      renderLogic: (row: any) => {
        return (
          // <p className=" text-primary-main font-normal font-weight-500">
          <p className=" text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.date}
          </p>
        );
      },
    },
    {
      field: "Visit Type",
      label: <div>Visit Type</div>,
      renderLogic: (row: any) => {
        return <p className=" text-neutral-90 font-normal">{row?.type}</p>;
      },
    },
    // {
    //   field: "visitLocation",
    //   label: <div>Visit Location</div>,
    //   renderLogic: (row: any) => {
    //     return <p className="text-neutral-90 font-normal">{row?.baseCamp}</p>;
    //   },
    // },
    {
      field: "chiefComplaint",
      label: <div>Chief Complaint</div>,
      renderLogic: (row: any) => {
        return (
          <p
            className="text-neutral-90 cursor-pointer common-text-ellipse-style"
            onClick={() => {
              // navigate(`/patient/${row}`);
            }}
          >
            <TooltipForTable label={row?.chiefComplaint || "-"} />
          </p>
        );
      },
    },
    {
      field: "typeOfCare",
      label: <div>Type of Care</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.care}</p>;
      },
    },

    {
      field: "Status",
      label: <div>Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getStatusTextColor(row?.status),
                background: getStatusBackground(row?.status),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getStatusDotColor(row?.status),
                  borderRadius: "50%",
                }}
              ></span>
              {destructStatusData(row?.status)}
            </span>
          </div>
        );
      },
    },

    {
      field: "Signed/Unsigned",
      label: <div>Signed/Unsigned</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <span
              className="font-weight-400 font-size-12px flex gap-1 items-center"
              style={{
                color: getSignTextColor(row?.visitSigned),
                background: getSignBackground(row?.visitSigned),
                borderRadius: "46px",
                padding: "4px 12px",
              }}
            >
              <span
                className="w-2 h-2"
                style={{
                  background: getSignDotColor(row?.visitSigned),
                  borderRadius: "50%",
                }}
              ></span>
              {row?.visitSigned === "na"
                ? "N/A"
                : row?.visitSigned
                  ? "Signed"
                  : "Unsigned"}
            </span>
          </div>
          // <p className="text-neutral-90 font-normal">
          //   {row?.visitSigned ? "Signed" : "Unsigned"}
          // </p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        const options: any = [];

        let addNewVisitNoteOption: any = {};
        if (row?.visitNoteData?.length) {
          row?.visitNoteData?.map((data: any, index: number) => {
            if (
              data?.status === "discharged" ||
              data?.status === "transferOffProperty" ||
              data?.status === "transferToClinic" ||
              data?.status === "transferToJHC"
            ) {
              options.push({
                label: `View Visit Note ${index + 1}`,
                disabled: !userPermissionData?.visit?.view,
                onClickCb: () => {
                  const payload = {
                    id: row?.id,
                    comesFrom: "viewVisitNote",
                  };
                  setVisitId("");
                  dispatch(setNotesData(data));
                  dispatch(getVisitNoteById(payload));
                  dispatch(setOrderChange(true));

                  setIsSignedVisit(true);
                },
              });

              // Note: transferOffProperty (offsite) is intentionally NOT a blocker
              // here so a completed offsite note can offer "Add New Visit Note",
              // matching transferToClinic/transferToJHC. Draft/InDisposition/unsigned
              // still hide it until the current note is finished.
              const hasDischarged = row?.visitNoteData?.some(
                (item: any) =>
                  item.status === "discharged" ||
                  item.status === "Draft" ||
                  item.status === "InDisposition" ||
                  !item?.isVisitSign,
              );

              // Transfer Off Property terminates the visit (no serial notes),
              // EXCEPT for EMS Scene visits — those keep "Add New Visit Note".
              // transferToClinic/transferToJHC/offsite still allow serial notes.
              if (!hasDischarged) {
                if (
                  data?.status === "transferToClinic" ||
                  data?.status === "transferToJHC" ||
                  (data?.status === "transferOffProperty" &&
                    row?.visitTypeRaw === "Scene") ||
                  isOffsiteTypeOfCare(data?.typeOfCare)
                ) {
                  // Check if "Add New Visit Note" is already in options
                  const addNewNoteExists = options?.some(
                    (option: any) => option.label === "Add New Visit Note",
                  );

                  if (!addNewNoteExists) {
                    addNewVisitNoteOption = {
                      label: "Add New Visit Note",
                      disabled:
                        (!isFacilityAgnosticAdmin &&
                          !(
                            viewPatientProfileData?.isAssigned &&
                            viewPatientProfileData?.facilityId ===
                              loginUserFacilityId
                          )) || !userPermissionData?.visit?.create,
                      onClickCb: () => {
                        setVisitId("");
                        dispatch(setVisitNoteCareFlowData({}));
                        dispatch(setNotesData({}));
                        dispatch(setOrderChange(false));

                        if (isOffsiteTypeOfCare(row?.care1Copy)) {
                          navigate(
                            `view-offsite-transfers-care-visit-note/${row?.id}?isAddNewNote=${true}`,
                          );
                        } else if (row?.care1Copy === "Self_Care") {
                          navigate(
                            `view-self-care-visit-note/${row?.id}?isAddNewNote=${true}`,
                          );
                        } else if (isNurseTypeOfCare(row?.care1Copy)) {
                          navigate(
                            `view-nurse-care-visit-note/${row?.id}?isAddNewNote=${true}`,
                          );
                        } else if (
                          row?.care1Copy?.toLowerCase()?.includes("mental")
                        ) {
                          navigate(
                            `view-mental-health-care-visit-note/${row?.id}?isAddNewNote=${true}`,
                          );
                        } else if (
                          row?.care1Copy?.toLowerCase()?.includes("ear")
                        ) {
                          navigate(
                            `view-listening-ear-care-visit-note/${row?.id}?isAddNewNote=${true}`,
                          );
                        } else {
                          navigate(
                            `view-physician-care-visit-note/${row?.id}?isAddNewNote=${true}`,
                          );
                        }
                      },
                    };
                  }
                }
              }
            } else {
              options.push({
                label: "View Visit Note",
                disabled:
                  (!isFacilityAgnosticAdmin &&
                    !(
                      viewPatientProfileData?.isAssigned &&
                      viewPatientProfileData?.facilityId === loginUserFacilityId
                    )) || !userPermissionData?.visit?.view,
                onClickCb: () => {
                  setVisitId("");
                  dispatch(setVisitNoteCareFlowData({}));
                  dispatch(setNotesData(data));
                  dispatch(setOrderChange(true));

                  if (isOffsiteTypeOfCare(row?.care1Copy)) {
                    navigate(
                      `view-offsite-transfers-care-visit-note/${row?.id}?isAddNewNote=${true}&newNoteStatus=${data?.status}`,
                    );
                  } else if (row?.care1Copy === "Self_Care") {
                    navigate(
                      `view-self-care-visit-note/${row?.id}?isAddNewNote=${true}&newNoteStatus=${data?.status}`,
                    );
                  } else if (isNurseTypeOfCare(row?.care1Copy)) {
                    navigate(
                      `view-nurse-care-visit-note/${row?.id}?isAddNewNote=${true}&newNoteStatus=${data?.status}`,
                    );
                  } else if (
                    row?.care1Copy?.toLowerCase()?.includes("mental")
                  ) {
                    navigate(
                      `view-mental-health-care-visit-note/${row?.id}?isAddNewNote=${true}&newNoteStatus=${data?.status}`,
                    );
                  } else if (row?.care1Copy?.toLowerCase()?.includes("ear")) {
                    navigate(
                      `view-listening-ear-care-visit-note/${row?.id}?isAddNewNote=${true}&newNoteStatus=${data?.status}`,
                    );
                  } else {
                    navigate(
                      `view-physician-care-visit-note/${row?.id}?isAddNewNote=${true}&newNoteStatus=${data?.status}`,
                    );
                  }
                },
              });
            }
          });
          // Add "Add New Visit Note" at the end of the options if it's prepared
          if (addNewVisitNoteOption?.label) {
            options.push(addNewVisitNoteOption);
          }
          if (
            // Discharged ends the workflow. Transfer Off Property also terminates
            // the visit (no repeat vitals) EXCEPT for EMS Scene visits.
            row?.status !== "discharged" &&
            (row?.status !== "transferOffProperty" ||
              row?.visitTypeRaw === "Scene")
          ) {
            if (
              row?.care1Copy !== "Self_Care" &&
              !row?.care1Copy?.toLowerCase()?.includes("ear") &&
              !row?.care1Copy?.toLowerCase()?.includes("mental") &&
              !isOffsiteTypeOfCare(row?.care1Copy)
              // row?.status !== "transferToClinic" &&
              // row?.status !== "transferToJHC"
            ) {
              options?.push({
                label: row?.triage?.length ? "Add Rpt Vitals" : "Add Vitals",
                // disabled: !viewPatientProfileData?.isAssigned,
                onClickCb: () => {
                  setVisitId(row?.id);
                  setOpenTriage(true);
                },
              });
            }
          }
        } else {
          options.push({
            label: "View Visit Note",
            disabled:
              (!isFacilityAgnosticAdmin &&
                !(
                  viewPatientProfileData?.isAssigned &&
                  viewPatientProfileData?.facilityId === loginUserFacilityId
                )) || !userPermissionData?.visit?.view,
            onClickCb: () => {
              setVisitId("");
              dispatch(setNotesData({}));
              dispatch(setOrderChange(true));
              dispatch(setVisitNoteCareFlowData({}));
              if (isOffsiteTypeOfCare(row?.care1Copy)) {
                navigate(`view-offsite-transfers-care-visit-note/${row?.id}`);
              } else if (row?.care1Copy === "Self_Care") {
                navigate(`view-self-care-visit-note/${row?.id}`);
              } else if (isNurseTypeOfCare(row?.care1Copy)) {
                navigate(`view-nurse-care-visit-note/${row?.id}`);
              } else if (row?.care1Copy?.toLowerCase()?.includes("mental")) {
                navigate(`view-mental-health-care-visit-note/${row?.id}`);
              } else if (row?.care1Copy?.toLowerCase()?.includes("ear")) {
                navigate(`view-listening-ear-care-visit-note/${row?.id}`);
              } else {
                navigate(`view-physician-care-visit-note/${row?.id}`);
              }
            },
          });
          if (
            row?.care1Copy !== "Self_Care" &&
            !row?.care1Copy?.toLowerCase()?.includes("ear") &&
            !row?.care1Copy?.toLowerCase()?.includes("mental") &&
            !isOffsiteTypeOfCare(row?.care1Copy)
            // row?.status !== "transferToClinic" &&
            // row?.status !== "transferToJHC"
          ) {
            options?.push({
              label: row?.triage?.length ? "Add Rpt Vitals" : "Add Vitals",
              // disabled: !viewPatientProfileData?.isAssigned,
              onClickCb: () => {
                setVisitId(row?.id);
                setOpenTriage(true);
              },
            });
          }
        }

        // Assign to me / Unassign — always available (not gated on triage),
        // so providers can take/continue ownership e.g. in the JHC transfer flow.
        options?.push({
          label: viewPatientProfileData?.isAssigned
            ? "Unassign"
            : "Assign to me",
          onClickCb: () => {
            const isAssigning = !viewPatientProfileData?.isAssigned;
            dispatch(
              patchPatient({
                id: viewPatientProfileData?.id,
                apiPayload: {
                  assigenProvider: JSON.stringify(
                    !viewPatientProfileData?.isAssigned
                  ),
                },
              })
            );
            // Auto-open Room Assignment when assigning a non-Self-Care patient.
            if (isAssigning && row?.care1Copy !== "Self_Care") {
              setRoomAssignmentVisitId(row?.id);
              setOpenRoomAssignmentDialog(true);
            }
          },
          disabled: false,
        });

        // Room Assignment — for every care type except Self Care; available for
        // any patient at your facility (no provider assignment required).
        if (row?.care1Copy !== "Self_Care") {
          options?.push({
            label: "Room Assignment",
            disabled: !(
              viewPatientProfileData?.facilityId === loginUserFacilityId
            ),
            onClickCb: () => {
              setRoomAssignmentVisitId(row?.id);
              setOpenRoomAssignmentDialog(true);
            },
          });
        }

        // Delete visit — enabled only for SuperAdmin/Admin users with
        // provider-portal access; disabled (visible) for everyone else.
        options?.push({
          label: "Delete",
          disabled: !canDeleteVisit,
          onClickCb: () => {
            setVisitToDelete(row);
            setOpenDeleteVisitConfirmDialog(true);
          },
        });

        return (
          <>
            <div className="flex items-center">
              <MenuDropdown options={options} />
            </div>
          </>
        );
      },
    },
  ];

  // VISIT TAB ROW DATA
  const visitTabRowData = tableDataForVisitTab?.visit?.map((data: any) => {
    return {
      id: data?.id,
      date: data?.updatedAt
        ? moment(data?.updatedAt)?.format("MM/DD/YYYY")
        : "-",
      type:
        data?.type === "WALK_In_Visit"
          ? "Walk In"
          : data?.type === "Scene"
            ? "EMS Scene"
            : "EMS",
      // Raw visit type ("Scene" = EMS Scene) — used to keep off-property EMS
      // visits alive while other off-property visits terminate.
      visitTypeRaw: data?.type,
      status: data?.status ? data?.status : "-",
      chiefComplaint: data?.chiefComplaints,
      care: data?.typeOfCare ? data?.typeOfCare?.split("_")?.join(" ") : "-",
      care1Copy: data?.typeOfCare ? data?.typeOfCare : "-",
      baseCamp: data?.campName ? data?.campName : "-",
      triage: data?.triage,
      visitSigned:
        !data?.visit_note || data?.visit_note?.length === 0
          ? "na"
          : data?.visit_note?.some((item: any) => item.isVisitSign === true),
      visitNoteData: data?.visit_note,
    };
  });

  // ORDER TAB COLUMN DATA
  const patientOrdersTabColumns = [
    {
      field: "ordersDate",
      label: <div>Order Date</div>,
      renderLogic: (row: any) => {
        return (
          // <p className=" text-primary-main font-normal font-weight-500">
          <p className=" text-neutral-90 font-normal common-text-ellipse-style ">
            {row?.orderDate}
          </p>
        );
      },
    },
    {
      field: "orderType",
      label: <div>{TEXT_CONSTANTS?.ORDER_TYPE}</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90" onClick={() => {}}>
            {row?.orderType}
          </p>
        );
      },
    },
    {
      field: "medicationName",
      label: <div>Item/{TEXT_CONSTANTS?.MEDICATION_NAME}</div>,
      renderLogic: (row: any) => {
        // Create tooltip content with all items (only item names)
        const tooltipContent =
          row?.allItems &&
          Array.isArray(row?.allItems) &&
          row?.allItems?.length > 0
            ? row?.allItems
                ?.map((item: any, index: number) => {
                  return item?.medicationName || item?.name || "-";
                })
                .join(", ")
            : row?.medicationName || "-";

        return (
          <p className="text-neutral-90 font-normal">
            <TooltipForTable label={tooltipContent} />
          </p>
        );
      },
    },
    {
      field: "orderDetails",
      label: <div>Order Details</div>,
      renderLogic: (row: any) => {
        const orderItems = Array.isArray(row?.allItems) ? row.allItems : [];
        const qtyChipStyle: React.CSSProperties = {
          borderRadius: "46px",
          padding: "2px 10px",
          fontSize: "12px",
          lineHeight: "18px",
          whiteSpace: "nowrap",
          background: "#EAF2FB",
          color: "#005596",
        };
        const freqChipStyle: React.CSSProperties = {
          ...qtyChipStyle,
          background: "#EEF2F6",
          color: "#475569",
          textTransform: "capitalize",
        };
        const hasDetail = orderItems.some(
          (it: any) =>
            it?.medicationName ||
            it?.name ||
            it?.quantity ||
            it?.frequency
        );
        if (!orderItems.length || !hasDetail) {
          return <span className="text-neutral-90 font-normal">-</span>;
        }
        return (
          <div className="flex flex-col gap-2" style={{ minWidth: "240px" }}>
            {orderItems.map((item: any, idx: number) => {
              const name = item?.medicationName || item?.name;
              const hasQty =
                item?.quantity !== undefined &&
                item?.quantity !== null &&
                item?.quantity !== "";
              if (!name && !hasQty && !item?.frequency) return null;
              return (
                <div
                  key={idx}
                  className="flex items-center gap-2 flex-wrap"
                >
                  <span className="text-neutral-90 font-weight-500">
                    {name || "-"}
                  </span>
                  {hasQty && (
                    <span style={qtyChipStyle}>{`Qty: ${item?.quantity}`}</span>
                  )}
                  {item?.frequency && (
                    <span style={freqChipStyle}>{item?.frequency}</span>
                  )}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      field: "note",
      label: <div>Note</div>,
      renderLogic: (row: any) => {
        return <TooltipForTable label={row?.note || "-"} />;
      },
    },
    {
      field: "orderedStatus",
      label: <div>Order Status</div>,
      renderLogic: (row: any) => {
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
              <span
                className="font-weight-400 font-size-12px flex gap-1 items-center"
                style={{
                  color: getStatusTextColor(row?.orderStatus),
                  background: getStatusBackground(row?.orderStatus),
                  borderRadius: "46px",
                  padding: "4px 12px",
                }}
              >
                {row?.orderStatus && (
                  <span
                    className="w-2 h-2"
                    style={{
                      background: getStatusDotColor(row?.orderStatus),
                      borderRadius: "50%",
                    }}
                  ></span>
                )}
                {destructStatusData(row?.orderStatus) || "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      field: "orderedBy",
      label: <div>Ordered By</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.orderedBy}</p>;
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Order",
                    onClickCb: () => {
                      setOpenViewOrderDialog({ open: true, defaultData: row });
                      // navigate(`/patient/${row}`);
                    },
                  },

                  {
                    label: "Verify Order",
                    onClickCb: () => {
                      setDefaultDataRowForOrder(row);
                      setOpenVerifyOrderDialog(true);
                    },
                  },

                  {
                    label: "Add Note",
                    onClickCb: () => {
                      setSelectedOrderForNotes(row);
                      setOpenViewNotesModal(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // VISIT TAB ROW DATA
  const ordersTabRowData = tableDataForOrderTab?.order?.map((data: any) => ({
    orderDate: data?.createdAt
      ? moment(data?.createdAt).format("MM/DD/YYYY")
      : "-",
    orderStatus: data?.status,
    medicationName: (() => {
      if (data?.item && Array.isArray(data?.item) && data?.item?.length > 0) {
        // If multiple items, show first item with count
        if (data?.item?.length > 1) {
          const firstItem = data?.item?.[0];
          return `${firstItem?.medicationName || firstItem?.name || "-"} (+${data?.item?.length - 1} more)`;
        } else {
          // Single item
          return (
            data?.item?.[0]?.medicationName || data?.item?.[0]?.name || "-"
          );
        }
      }
      return "-";
    })(),
    // Store all items for tooltip display. Frequency lives on the order (not
    // per-item), so inject it into each item for the Order Details chip.
    allItems: (data?.item || []).map((it: any) => ({
      ...it,
      frequency: data?.frequency,
    })),
    orderedBy: `${data?.orderdBy?.firstName || "-"} ${data?.orderdBy?.lastName || ""}`,
    orderType:
      data?.type === "Rx Order"
        ? "Medication"
        : data?.type === "Care_Kit"
          ? "Care Kit"
          : data?.type === "X_Ray"
            ? "X Ray"
            : data?.type,
    note: data?.note,
    id: data?.id,
  }));

  // OPEN VIEW PREV  DIALOG
  useEffect(() => {
    if (openVisitPreviewDialog) {
      setOpenPreviewForm(true);
      dispatch(setVisitPreviewDialog(false));
      dispatch(
        setDataToDischargeForm({
          ...visitNoteCareFlowData,
        }),
      );
    }
  }, [openVisitPreviewDialog]);

  useEffect(() => {
    dispatch(getViewPatientProfileData({}));
    try {
      dispatch(getPatientProfileData(patientId));
    } catch (error) {
      console.log("error:", error);
    }
  }, [closeEditProfileDialog, patientId, closeCreateVisitDrawer]);

  // Refresh the patient profile after an assign/unassign toggle so the
  // "Assign to me"/"Unassign" label reflects the new isAssigned state.
  useEffect(() => {
    if (refreshPatientList) {
      dispatch(setRefreshPatientList(false));
      dispatch(getPatientProfileData(patientId));
    }
  }, [refreshPatientList]);

  // CLOSE CREATE PATIENT DRAWER
  useEffect(() => {
    if (closeCreatePatientDrawer) {
      setOpenCreateVisitDialog(true);
      dispatch(setCloseCreatePatientDrawer(false));
    }
  }, [closeCreatePatientDrawer]);

  // CLOSE CREATE VISIT — triage is decoupled from visit creation, so the
  // triage modal no longer auto-opens. Staff start triage on demand via the
  // "Add Triage" action once the patient is ready to be seen.
  useEffect(() => {
    if (closeCreateVisitDrawer) {
      setOpenCreateVisitDialog(false);
      dispatch(setCreateVisitDataForTriage({}));
      dispatch(setCloseCreateVisitDrawer(false));
      setOpenConfirmationDialog(false);
      dispatch(setOpenCreateVisitForceFullyDialog(false));
      setSaveCreateVisitDataTemporary({});
    }
  }, [closeCreateVisitDrawer]);

  useEffect(() => {
    if (openCreateVisitForceFullyDialog) {
      setOpenConfirmationDialog(true);
      dispatch(setOpenCreateVisitForceFullyDialog(false));
    }
  }, [openCreateVisitForceFullyDialog]);

  // CLOSE TRIAGE DRAWER
  useEffect(() => {
    if (closeTriageDrawer) {
      setOpenTriage(false);
      dispatch(setCloseCreateTriageDrawer(false));
    }
  }, [closeTriageDrawer]);

  useEffect(() => {
    if (updateVisitNoteDataOnceDraftNote) {
      setOpenPreviewForm(false);
      setUpdateVisitNoteDataOnceDraftNote(false);
    }
    if (closeVerifyOrderStatus) {
      setOpenVerifyOrderDialog(false);
      dispatch(setCloseVerifyOrderStatus(false));
    }
    if (closeEmergencyContactDialog) {
      setOpenEmergencyContactDialog(false);
      dispatch(setCloseEmergencyContactDialog(false));
    }
    if (closeBaseCampDialog) {
      setOpenUnitLeaderDialog(false);
      dispatch(setCloseBaseCampDialog(false));
    }
    if (selectedTab === "visits" || selectedTab === "orders") {
      const payload = {
        apiQuery:
          viewPatientProfileData?.id && selectedTab
            ? `patient/${viewPatientProfileData.id}?searchCriteria=${encodeURIComponent(selectedTab.substring(0, 5))}+${pageNumber ? "&pageNumber=" + pageNumber : ""}+${rowPerPage ? "&limit=" + rowPerPage : ""}`
            : null, // Or handle a default value
        selectedTab: selectedTab,
      };
      if (viewPatientProfileData?.id && selectedTab) {
        dispatch(getPatientDetailsDataByTabWise(payload));
      }
    } else if (selectedTab === "eCI") {
      const payload = {
        apiQuery:
          viewPatientProfileData?.id && selectedTab
            ? `patient/${viewPatientProfileData.id}?searchCriteria=${encodeURIComponent("emergencycontact")}`
            : null, // Or handle a default value
        selectedTab: selectedTab,
      };

      if (viewPatientProfileData?.id && selectedTab) {
        dispatch(getPatientDetailsDataByTabWise(payload));
      }
    }
  }, [
    selectedTab,
    closeCreateVisitDrawer,
    pageNumber,
    rowPerPage,
    closeEmergencyContactDialog,
    closeBaseCampDialog,
    updateVisitNoteDataOnceDraftNote,
    viewPatientProfileData,
    closeVerifyOrderStatus,
    closeTriageDrawer,
  ]);

  useEffect(() => {
    if (closeVerifyOrderStatus) {
      setOpenVerifyOrderDialog(false);
      dispatch(setCloseVerifyOrderStatus(false));
    }
  }, [closeVerifyOrderStatus]);

  // DEBOUNCE DOCUMENT SEARCH
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedDocumentSearch(documentSearchKey);
    }, 500);
    return () => clearTimeout(timer);
  }, [documentSearchKey]);

  // FETCH DOCUMENTS WHEN TAB IS DOCUMENTS
  useEffect(() => {
    if (selectedTab === "documents" && viewPatientProfileData?.id) {
      dispatch(
        getPatientDocuments({
          patientId: viewPatientProfileData.id,
          name: debouncedDocumentSearch || undefined,
        }),
      );
    }
  }, [selectedTab, debouncedDocumentSearch, viewPatientProfileData]);

  // CLOSE UPLOAD DOCUMENT DIALOG
  useEffect(() => {
    if (closeUploadDocumentDialog) {
      setOpenUploadDocumentDialog(false);
      dispatch(setCloseUploadDocumentDialog(false));
      // Refresh documents list
      if (viewPatientProfileData?.id) {
        dispatch(
          getPatientDocuments({
            patientId: viewPatientProfileData.id,
            name: debouncedDocumentSearch || undefined,
          }),
        );
      }
    }
  }, [closeUploadDocumentDialog]);

  // DOCUMENT TABLE COLUMNS
  const patientDocumentsTabColumns = [
    {
      field: "Name",
      label: <div>Name</div>,
      renderLogic: (row: any) => {
        return (
          <p className="font-size-14px font-weight-400 color-1D1D1D">
            {row?.documentName || "-"}
          </p>
        );
      },
    },
    {
      field: "Note",
      label: <div style={{ minWidth: "250px" }}>Note</div>,
      renderLogic: (row: any) => {
        return <TooltipForTable label={row?.note || "-"} />;
      },
    },
    {
      field: "Uploaded By",
      label: <div>Uploaded By</div>,
      renderLogic: (row: any) => {
        return (
          <p className="font-size-14px font-weight-400 color-1D1D1D">
            {row?.uploadedBy || "-"}
          </p>
        );
      },
    },
    {
      field: "Uploaded Date",
      label: <div>Uploaded Date</div>,
      renderLogic: (row: any) => {
        return (
          <p className="font-size-14px font-weight-400 color-1D1D1D">
            {row?.uploadedDate || "-"}
          </p>
        );
      },
    },
    {
      field: "Actions",
      label: <div>Actions</div>,
      renderLogic: (row: any) => {
        return (
          <MenuDropdown
            options={[
              {
                label: "View",
                onClickCb: () => {
                  setDocumentToView(row);
                  setOpenViewDocumentDialog(true);
                },
              },
              {
                label: "Download",
                onClickCb: async () => {
                  if (row?.id) {
                    try {
                      const response =
                        await PatientListService.downloadPatientDocument(
                          row.id,
                        );
                      const contentType =
                        response.headers["content-type"] ||
                        "application/octet-stream";
                      const blob = new Blob([response.data], {
                        type: contentType,
                      });
                      const blobUrl = window.URL.createObjectURL(blob);
                      const contentDisposition =
                        response.headers["content-disposition"];
                      let fileName = "";
                      if (contentDisposition) {
                        const match =
                          contentDisposition.match(
                            /filename="?(.+?)"?$/,
                          );
                        if (match) fileName = match[1];
                      }
                      if (!fileName) {
                        const extMap: Record<string, string> = {
                          PDF: ".pdf",
                          PNG: ".png",
                          JPG: ".jpg",
                          JPEG: ".jpeg",
                          DOC: ".doc",
                          DOCX: ".docx",
                        };
                        const ext =
                          extMap[row?.type?.toUpperCase()] || "";
                        const baseName =
                          row?.documentName || "document";
                        fileName = baseName.includes(".")
                          ? baseName
                          : `${baseName}${ext}`;
                      }
                      const link = document.createElement("a");
                      link.href = blobUrl;
                      link.download = fileName;
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(blobUrl);
                    } catch (error) {
                      console.error("Download failed:", error);
                    }
                  }
                },
              },
              {
                label: "Delete",
                onClickCb: () => {
                  setDocumentToDelete(row);
                  setOpenDeleteDocConfirmDialog(true);
                },
              },
            ]}
          />
        );
      },
    },
  ];

  // DOCUMENT TABLE ROW DATA
  const allDocumentsRowData =
    tableDataForDocumentsTab?.data?.map((data: any) => ({
      id: data?.id || data?._id,
      documentName: data?.name,
      uploadedDate: data?.createdAt
        ? moment(data.createdAt).format("MM/DD/YYYY")
        : "-",
      note: data?.note,
      uploadedBy: data?.creator
        ? `${data.creator.firstName || ""} ${data.creator.lastName || ""}`.trim()
        : "-",
      fileUrl: data?.file,
      type: data?.type,
    })) || [];

  // CLIENT-SIDE PAGINATION FOR DOCUMENTS
  const documentLimit = Number(documentRowPerPage) || 5;
  const documentTotalCount = allDocumentsRowData.length;
  const documentTotalPages = Math.ceil(documentTotalCount / documentLimit);
  const documentsTabRowData = allDocumentsRowData.slice(
    (documentPageNumber - 1) * documentLimit,
    documentPageNumber * documentLimit,
  );

  // HANDLE UPLOAD DOCUMENT
  const handleUploadDocument = (data: {
    file: string;
    name: string;
    note: string;
    type: string;
  }) => {
    if (viewPatientProfileData?.id) {
      dispatch(
        uploadPatientDocument({
          data: {
            patientId: viewPatientProfileData.id,
            name: data.name,
            note: data.note,
            file: data.file,
            type: data.type,
            facilityId: loginUserFacilityId,
          },
        }),
      );
    }
  };

  // HANDLE DELETE DOCUMENT
  const handleDeleteDocument = () => {
    if (documentToDelete?.id) {
      dispatch(
        deletePatientDocument({
          documentId: documentToDelete.id,
        }),
      );
      setOpenDeleteDocConfirmDialog(false);
      setDocumentToDelete(null);
    }
  };

  // HANDLE DELETE VISIT
  const handleDeleteVisit = () => {
    if (visitToDelete?.id) {
      dispatch(deleteVisit({ visitId: visitToDelete.id }));
      setOpenDeleteVisitConfirmDialog(false);
      setVisitToDelete(null);
    }
  };

  // CREATE VISIT FORM FUNCTION
  const handleCreatedPatientVisitFormData = (
    formData: any,
    type: string,
    comesFrom?: string,
  ) => {
    if (comesFrom !== "createVisitForceFully") {
      const payload = {
        apIPayload: {
          type: type === "ems" ? "EMS_Visit" : "WALK_In_Visit",
          patientId: viewPatientProfileData?.id,
          chiefComplaints: formData?.chiefComplaint,
          incidentDate:
            type === "ems"
              ? moment()?.format("YYYY-MM-DD")
              : formData?.incidentDate
                ? moment(formData?.incidentDate)?.format("YYYY-MM-DD")
                : undefined,
          incidentTime:
            type === "ems"
              ? moment().format("HH:mm")
              : formData?.incidentTime
                ? formData?.incidentTime?.format("HH:mm")
                : undefined,
          incidentlocation: formData?.incidentLocation,
          witnessName: formData?.witnessName,
          witnessEmail: formData?.witnessEmail,
          injuryType: formData?.injuryType,
          injuryLocation: formData?.injuryLocation,
          // departmentId:
          //   formData?.typeOFCare !== "Self_Care"
          //     ? formData?.typeOFCare
          //     : undefined,
          // typeOfCare: formData?.typeOfCareName,
          // facilityId: formData?.facility,
          departmentId:
            type !== "ems" && formData?.typeOFCare !== "Self_Care"
              ? formData?.typeOFCare
              : undefined,
          typeOfCare: type !== "ems" ? formData?.typeOfCareName : undefined,
          facilityId: type !== "ems" ? formData?.facility : undefined,
        },
        force: false,
      };
      dispatch(createNewVisit(payload));
      setSaveCreateVisitDataTemporary(payload);
    } else if (comesFrom === "createVisitForceFully") {
      // setSaveCreateVisitDataTemporary((prevData:any)=>({
      //   ...prevData,
      // }))
      const payload = {
        apIPayload: saveCreateVisitDataTemporary?.apIPayload,
        force: true,
      };
      dispatch(createNewVisit(payload));
    }
  };

  // CREATE TRIAGE FUNCTION
  const handleCreateTriageDialog = (formData: any) => {
    const payload = {
      apiPayload: {
        patientId: createVisitDataFormTriage?.patientId || patientId,
        visitId: visitId || createVisitDataFormTriage?.visitId,
        // Only send vitals that were actually entered (omit blanks).
        temperature: formData?.temperature
          ? Number(formData?.temperature)
          : undefined,
        oxygenSaturation: formData?.oxygenSaturation
          ? Number(formData?.oxygenSaturation)
          : undefined,
        heartRate: formData?.heathRate
          ? Number(formData?.heathRate)
          : undefined,
        respirationRate: formData?.respirationRate
          ? Number(formData?.respirationRate)
          : undefined,
        systolic: formData?.bloodPressure
          ? Number(formData?.bloodPressure)
          : undefined,
        diastolic: formData?.bloodPressure2
          ? Number(formData?.bloodPressure2)
          : undefined,
        woundCare: formData?.care === "woundCare" ? true : false,
        woundlocation:
          formData?.care === "woundCare" ? formData?.careValue : "",
        dehydration: formData?.care === "dehydration" ? true : false,
        dehydrationLevel:
          formData?.care === "dehydration" ? formData?.careValue : "",
        injury: formData?.care === "injury" ? true : false,
        injurylocation: formData?.care === "injury" ? formData?.careValue : "",
        other: formData?.care === "other" ? true : false,
        details: formData?.care === "other" ? formData?.careValue : "",
        triageTakenBy: formData?.triageTakenId,
        location: formData?.triageTakenLocation
          ? formData?.triageTakenLocation === "clinicLocation"
            ? "Clinic Location"
            : "JHC"
          : undefined,
      },
      comesFrom: "patientScreen",
    };
    dispatch(createTriage(payload));
  };
  // HANDLE SUBMIT EMERGENCY DETAILS DATA
  const handleSubmitEmergencyDetailsData = (formData: any) => {
    try {
      const payload = {
        patientId: patientId,
        apiPayload: {
          emergencyContact: {
            id: emergencyContact?.id,
            contactName: formData?.ContactName || undefined,
            contactRelation: formData?.ContactRelation || undefined,
            contactEmail: formData?.ContactEmail || undefined,
            contactNumber: formData?.ContactNumber || undefined,
          },
        },
      };
      dispatch(patchEmergencyContactData(payload));
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSubmitUnitLeaderData = (formData: any) => {
    try {
      const payload = {
        patientId,
        apiPayload: {
          campId: formData?.clinicLocation || unitContact?.id,
          unitNumber: formData?.unitNumber || undefined,
          leaderName: formData?.leaderName || undefined,
          email: formData?.email || undefined,
          leaderContact: formData?.leaderContact || undefined,
        },
      };
      dispatch(patchBaseCampData(payload));
    } catch (error) {
      console.log("error", error);
    }
  };
  //PATCH FOR VERIFY ORDER STATUS
  const handleVerifyOrder = (data: any) => {
    if (!defaultDataRowForOrder?.id) {
      console.error(
        `Order ID is missing! Ensure data is loaded before calling this function. id: ${defaultDataRowForOrder?.id}`,
      );
      return;
    }
    if (defaultDataRowForOrder && defaultDataRowForOrder?.id) {
      const apiPayload = {
        payload: {
          status: data?.status,
        },
        orderId: defaultDataRowForOrder?.id,
      };

      dispatch(patchVerifyOrder(apiPayload));
    }
  };
  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0 flex flex-col"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col flex-1 min-h-0 gap-3">
        {/*  SCREEN HEADER */}
        <div className={`flex items-center justify-between w-full`}>
          <Heading title="Profile" />

          <Button
            disabled={!userPermissionData?.visit?.create}
            label={TEXT_CONSTANTS?.CREATE_VISIT}
            variant="contained"
            onClickCb={() => {
              setVisitId("");
              setOpenCreateVisitDialog(true);
            }}
            style={{
              padding: "6px 17px",
            }}
          ></Button>
        </div>
        {/* MAIN CONTENT */}
        <div
          style={{
            overflow: "auto",
            flex: "1 1 0%",
            minHeight: 0,
            paddingRight: hasOverflow ? "6px" : 0,
          }}
          ref={divRef}
        >
          {/* PATIENT PROFILE DETAILS CARD */}
          <EventEHRPatientProfileDetailCardWithEdit
            patientDetails={patientDetails}
            onEditClick={() => setOpenEditProfileDialog(true)}
            handleClickEvent={() => {
              getHealthHistory(viewPatientProfileData?.id, dispatch);
            }}
            profileImage={
              patientProfileData?.profileImage &&
              patientProfileData.profileImage.trim()
                ? patientProfileData.profileImage
                : ""
              // : dummyAvatar
            }
          />
          {/* TABS AND TAB WISE SCREEN HERE */}
          <div className="mt-3">
            {/* REUSABLE TAB COMPONENT */}
            <EventEHRTabs
              defaultSelectedValue={selectedTab}
              tabList={[
                // { label: "Health History", value: "healthHistory" },
                { label: "Visits", value: "visits" },
                { label: "Orders", value: "orders" },
                { label: "Emergency Contact Information", value: "eCI" },
                { label: "Documents", value: "documents" },
              ]}
              onChangeTab={(tab) => {
                setPageNumber(1);
                setRowPerPage("10");
                setDocumentPageNumber(1);
                setDocumentRowPerPage("10");
                setSelectedTab(tab);
              }}
            />
            {/* IF SELECTED TAB IS Health History */}
            {/* {selectedTab === "healthHistory" && (
              <div className="mt-5 tab-main-content-height">
                <div
                  className="flex justify-center items-center flex-col background-color-F1F1F1 border-radius-8px  gap-6"
                  style={{ padding: "60px 28px" }}
                >
                  <div className="font-size-18px font-weight-500 color-565656">
                    Click the button to view health records on CampDoc.
                  </div>
                  <Button
                    label={TEXT_CONSTANTS?.OPEN_HEALTH_HISTORY}
                    variant="contained"
                    onClickCb={() => {
                      const payload = {
                        apiQuery:
                          viewPatientProfileData?.id && selectedTab
                            ? `patient/${viewPatientProfileData.id}?searchCriteria=${encodeURIComponent("health-history")}`
                            : null, // Or handle a default value
                        selectedTab: selectedTab,
                      };
                      if (viewPatientProfileData?.id && selectedTab) {
                        dispatch(getPatientDetailsDataByTabWise(payload));
                      }
                    }}
                    style={{
                      padding: "13px 28px",
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  ></Button>
                </div>
              </div>
            )} */}
            {/* IF SELECTED TAB IS Visits */}
            {selectedTab === "visits" && (
              <div
                // className="mt-5 tab-main-content-height"
                className="mt-5"
                // style={{ overflow: "auto" }}
              >
                <Table
                  columns={patientVisitTabColumns}
                  rows={visitTabRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalCount: tableDataForVisitTab?.total,
                    totalPages: tableDataForVisitTab?.totalPages,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS Orders */}
            {selectedTab === "orders" && (
              <div
                className="mt-5 tab-main-content-height"
                style={{ overflow: "auto" }}
              >
                <Table
                  columns={patientOrdersTabColumns}
                  rows={ordersTabRowData}
                  paginationProps={{
                    isPagination: true,
                    page: pageNumber,
                    totalCount: tableDataForOrderTab?.total,
                    totalPages: tableDataForOrderTab?.totalPages,
                    limit: rowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowPerPage: any) => {
                      setRowPerPage(rowPerPage);
                      setPageNumber(1);
                    },
                  }}
                />
              </div>
            )}

            {/* IF SELECTED TAB IS Emergency Contact Information */}
            {selectedTab === "eCI" && (
              <div
                className="mt-5 tab-main-content-height"
                style={{ overflow: "auto" }}
              >
                <div className="flex gap-[40px]">
                  <div className="mt-3">
                    {" "}
                    <EventEHRHeading
                      title="Emergency Contact Information"
                      customStyle={{
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "#1D1D1D",
                        marginBottom: "16px",
                      }}
                    />
                    <EventEHRContactInformationCard
                      headingTitle="Primary Contact"
                      handleOnChange={(value) => {
                        setOpenEmergencyContactDialog(true);
                      }}
                      isEditable={true}
                      contactInfoData={[
                        {
                          label: "Contact Name",
                          value: emergencyContact?.contactName || "-",
                        },
                        {
                          label: "Contact Relation",
                          value: emergencyContact?.contactRelation || "-",
                        },
                        {
                          label: "Contact Email",
                          value: emergencyContact?.contactEmail || "-",
                        },
                        {
                          label: "Contact Number",
                          value: emergencyContact?.contactNumber || "-",
                        },
                      ]}
                    />
                  </div>
                  <div className="mt-3">
                    <EventEHRHeading
                      title="Unit Contact Details"
                      customStyle={{
                        fontSize: "16px",
                        fontWeight: 500,
                        marginBottom: "16px",
                        color: "#1D1D1D",
                      }}
                    />
                    <div className="">
                      <EventEHRContactInformationCard
                        headingTitle="Unit Leader"
                        isEditable={true}
                        handleOnChange={() => {
                          setOpenUnitLeaderDialog(true);
                        }}
                        contactInfoData={[
                          {
                            label: "Unit Number",
                            value: unitContact?.unitNumber || "-",
                          },
                          {
                            label: "Unit Leader Name",
                            value: unitContact?.leaderName || "-",
                          },
                          {
                            label: "Unit Leader Email",
                            value: unitContact?.email || "-",
                          },
                          {
                            label: "Unit Leader Contact",
                            value: unitContact?.leaderContact,
                          },
                        ]}
                      />
                    </div>
                  </div>
                  <div className="mt-3">
                    <EventEHRHeading
                      title="Patient Contact Details"
                      customStyle={{
                        fontSize: "16px",
                        fontWeight: 500,
                        marginBottom: "16px",
                        color: "#1D1D1D",
                      }}
                    />
                    <div className="">
                      <EventEHRContactInformationCard
                        headingTitle="Patient Contact"
                        contactInfoData={[
                          {
                            label: "Patient Name",
                            value: `${patientProfileData?.firstName || "-"} ${patientProfileData?.lastName || ""}`,
                          },
                          {
                            label: "Date of Birth",
                            value: patientProfileData?.dateOfBirth
                              ? // DOB is date-only (midnight UTC) — render in UTC.
                                moment.utc(patientProfileData?.dateOfBirth)?.format(
                                  "MM/DD/YYYY",
                                )
                              : "-",
                          },
                          {
                            label: "Patient Email",
                            value: patientProfileData?.email || "-",
                          },
                          {
                            label: "Patient Contact",
                            value: patientProfileData?.contactNumber || "-",
                          },
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* IF SELECTED TAB IS Documents */}
            {selectedTab === "documents" && (
              <div className="mt-5">
                {/* Search + Upload Button */}
                <div className="flex items-center justify-end gap-3 mb-4">
                  <div style={{ width: "300px" }}>
                    <Input
                      placeholder="Search documents..."
                      value={documentSearchKey}
                      onChangeCb={(e) => {
                        setDocumentSearchKey(e.target.value);
                        setDocumentPageNumber(1);
                      }}
                      size="small"
                    />
                  </div>
                  <Button
                    label="Upload Document"
                    variant="contained"
                    onClickCb={() => setOpenUploadDocumentDialog(true)}
                    style={{
                      padding: "6px 17px",
                    }}
                  />
                </div>

                {/* Documents Table */}
                <Table
                  columns={patientDocumentsTabColumns}
                  rows={documentsTabRowData || []}
                  paginationProps={{
                    isPagination: true,
                    page: documentPageNumber,
                    totalCount: documentTotalCount,
                    totalPages: documentTotalPages,
                    limit: documentRowPerPage,
                    rowsPerPageOptions: [10, 25, 50],
                    onPageChange: (page: any) => {
                      setDocumentPageNumber(page);
                    },
                    handleChangeRowsPerPage: (rowsPerPage: any) => {
                      setDocumentRowPerPage(rowsPerPage);
                      setDocumentPageNumber(1);
                    },
                  }}
                  noDataFoundMessage="No documents found!"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* CREATE VISIT DIALOG */}
      {openCreateVisitDialog && (
        <EventEHRCreateVisitDialog
          formData={defaultSelectedDataOFCreateVisit}
          comesFrom={"patient"}
          dialogHeading={TEXT_CONSTANTS?.CREATE_VISIT}
          isOpen={openCreateVisitDialog}
          handleSubmittedData={(data, selectedVisitType) => {
            handleCreatedPatientVisitFormData(data, selectedVisitType);
          }}
          handleClose={() => {
            setOpenCreateVisitDialog(false);
            dispatch(setCloseCreateVisitDrawer(false));
          }}
          onEMSVisitSelected={() => navigate("/patient/jot-form")}
        />
      )}
      {/* EDIT PROFILE DIALOG */}
      {openEditProfileDialog && (
        <EventEHREditProfileDialog
          patientProfileData={patientProfileData}
          dialogHeading="Edit Profile"
          isOpen={openEditProfileDialog}
          handleClose={() => {
            setOpenEditProfileDialog(false);
          }}
        />
      )}
      {/* EDIT EMERGENCY DIALOG */}
      {openEmergencyContactDialog && (
        <EventEHREditEmergencyContactDialog
          defaultSelectedData={emergencyContact}
          dialogHeading="Edit Primary Contact"
          isOpen={openEmergencyContactDialog}
          handleClose={() => {
            setOpenEmergencyContactDialog(false);
          }}
          handleSubmittedEmergencyContactData={(formData) => {
            handleSubmitEmergencyDetailsData(formData);
          }}
        />
      )}
      {openUnitLeaderDialog && (
        <EventEHREditUnitLeaderDialog
          defaultSelectedData={unitContact}
          dialogHeading="Edit Unit Leader"
          isOpen={openUnitLeaderDialog}
          handleClose={() => {
            setOpenUnitLeaderDialog(false);
          }}
          handleSubmittedUnitLeaderData={(formData) => {
            handleSubmitUnitLeaderData(formData);
          }}
        />
      )}
      {/* CREATE TRIAGE DIALOG */}
      {openTriage && (
        <SaveTriageDialog
          ids={createVisitDataFormTriage}
          open={openTriage}
          handleCloseDialog={() => {
            setOpenTriage(false);
          }}
          handleTriageSubmittedData={(formData) => {
            handleCreateTriageDialog(formData);
          }}
        />
      )}
      <EventEHRConfirmationDialog
        alertTitle="Create New Visit"
        alertDescription="Do you want to proceed with creating a new visit? Please confirm to continue."
        cancelButtonTitle="Cancel"
        submitButtonTitle="Create"
        open={openConfirmationDialog}
        handleClose={(action) => {
          if (action === "close") {
            setOpenConfirmationDialog(false);
          } else if (action === "submit") {
            handleCreatedPatientVisitFormData(
              {},
              saveCreateVisitDataTemporary?.type,
              "createVisitForceFully",
            );
          }
        }}
      />
      {openPreviewForm && (
        <DischargeFormPreviewModel
          comesFrom={"viewVisitNote"}
          signVisit={isSignedVisit}
          patientId={patientId}
          visitNoteId={""}
          open={openPreviewForm}
          handleCloseModel={() => {
            setOpenPreviewForm(false);
            setIsSignedVisit(false);
          }}
        />
      )}
      {openViewOrderDialog && (
        <ViewOrderDialog
          dialogHeading="View Order Details"
          handleClose={() =>
            setOpenViewOrderDialog({ open: false, defaultData: {} })
          }
          defaultOrderList={openViewOrderDialog?.defaultData}
          isOpen={openViewOrderDialog?.open}
        />
      )}
      {openVerifyOrderDialog && (
        <VerifyOrderStatusDialog
          isOpen={openVerifyOrderDialog}
          defaultSelectedData={{}}
          handleClose={() => {
            setOpenVerifyOrderDialog(false);
          }}
          handleData={(values) => {
            handleVerifyOrder(values);
          }}
          label="Verify Order Status"
        />
      )}
      {openViewNotesModal && (
        <ViewNotesModal
          isOpen={openViewNotesModal}
          handleClose={() => {
            setOpenViewNotesModal(false);
            setSelectedOrderForNotes({});
          }}
          orderData={selectedOrderForNotes}
        />
      )}
      {/* UPLOAD DOCUMENT DIALOG */}
      {openUploadDocumentDialog && (
        <UploadDocumentDialog
          isOpen={openUploadDocumentDialog}
          handleClose={() => setOpenUploadDocumentDialog(false)}
          handleUpload={handleUploadDocument}
        />
      )}
      {/* DELETE DOCUMENT CONFIRMATION DIALOG */}
      <EventEHRConfirmationDialog
        alertTitle="Delete Document"
        alertDescription="Are you sure you want to delete this document? This action cannot be undone."
        cancelButtonTitle="Cancel"
        submitButtonTitle="Delete"
        open={openDeleteDocConfirmDialog}
        handleClose={(action) => {
          if (action === "close") {
            setOpenDeleteDocConfirmDialog(false);
            setDocumentToDelete(null);
          } else if (action === "submit") {
            handleDeleteDocument();
          }
        }}
      />
      {/* DELETE VISIT CONFIRMATION DIALOG */}
      <EventEHRConfirmationDialog
        alertTitle="Delete Visit"
        alertDescription="Are you sure you want to delete this visit? This permanently removes the visit and all of its related data (vitals, visit notes, orders, dispositions). This action cannot be undone."
        cancelButtonTitle="Cancel"
        submitButtonTitle="Delete"
        open={openDeleteVisitConfirmDialog}
        handleClose={(action) => {
          if (action === "close") {
            setOpenDeleteVisitConfirmDialog(false);
            setVisitToDelete(null);
          } else if (action === "submit") {
            handleDeleteVisit();
          }
        }}
      />
      {/* ROOM ASSIGNMENT DIALOG */}
      {openRoomAssignmentDialog && (
        <RoomAssignmentDialog
          isOpen={openRoomAssignmentDialog}
          handleClose={() => {
            setOpenRoomAssignmentDialog(false);
            setRoomAssignmentVisitId("");
          }}
          patientId={viewPatientProfileData?.id}
          visitId={roomAssignmentVisitId}
          facilityId={viewPatientProfileData?.facilityId}
          currentRoom={viewPatientProfileData?.room}
        />
      )}
      {/* VIEW DOCUMENT DIALOG */}
      {openViewDocumentDialog && documentToView && (
        <ViewDocumentDialog
          isOpen={openViewDocumentDialog}
          handleClose={() => {
            setOpenViewDocumentDialog(false);
            setDocumentToView(null);
          }}
          documentName={documentToView?.documentName || ""}
          fileUrl={documentToView?.fileUrl || ""}
          fileType={documentToView?.type || ""}
        />
      )}
    </WrapperCard>
  );
};

export default PatientDetailsScreen;
